// extracted by mini-css-extract-plugin
module.exports = {"Cancel":"DestructiveActionConfirmationModal_Cancel__1rtRb","Confirm":"DestructiveActionConfirmationModal_Confirm__2bIi4"};